import { type postDataSort } from '@shared/all/domains/posts';

const calculateStartEnd = (startDate: Date, type: postDataSort) => {
  let start: Date = new Date(startDate);
  let end: Date = new Date(startDate);

  if (type === 'DAILY') {
    start.setUTCHours(0, 0, 0);
    end.setUTCHours(23, 59, 59);
  } else if (type === 'WEEKLY') {
    const startOfWeek = new Date(start);
    const dayOfWeek = startOfWeek.getDay();
    const diffToSunday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust to get to the start of the week (Monday)
    startOfWeek.setDate(startOfWeek.getDate() + diffToSunday);
    start = new Date(startOfWeek);
    start.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    end = new Date(endOfWeek);
    end.setHours(23, 59, 59, 999);
  } else if (type === 'MONTHLY') {
    const startOfMonth = new Date(start.getFullYear(), start.getMonth(), 1);
    start = new Date(startOfMonth);
    start.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    end = new Date(endOfMonth);
    end.setHours(23, 59, 59, 999);
  }

  return {
    start,
    end
  };
};

export default calculateStartEnd;
